import { render, staticRenderFns } from "./FourD.vue?vue&type=template&id=c9db4830&scoped=true"
import script from "./FourD.vue?vue&type=script&lang=js"
export * from "./FourD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9db4830",
  null
  
)

export default component.exports